import {
	OEMS_FETCH_REQUEST,
	OEMS_FETCH_FAILURE,
	OEMS_FETCH_SUCCESS,
	OEM_CREATE_REQUEST,
	OEM_CREATE_FAILURE,
	OEM_CREATE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case OEMS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case OEMS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case OEMS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		case OEM_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case OEM_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case OEM_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/oems.js